module.exports = __webpack_public_path__ + "img/404.b369c6c9.png";